import {Component, inject, Input, OnInit} from '@angular/core';
import {DbActiveModal} from "../../../../../../../modules/modal/modal-ref";

@Component({
    selector: 'db-custom-domain-nameservers-modal',
    templateUrl: './custom-domain-nameservers-modal.component.html',
    styleUrl: './custom-domain-nameservers-modal.component.scss',
    standalone: false
})
export class CustomDomainNameserversModalComponent implements OnInit {
    nameservers = ['ns-721.awsdns-28.net', 'ns-721.awsdns-28.net', 'ns-721.awsdns-28.net', 'ns-721.awsdns-28.net'];
    public isCopied: any = [];
    texts = {
        title: `Domain added to your organization`,
        subtitle: `Replace the default nameservers at your domain registrar with 10Web nameservers to point<br>
      domain. It can take up to 24 hours to be resolved and activated.`
    }
    @Input() withError = true;
    @Input() default = false;
    @Input() pointed = false;
    private _activeModal = inject(DbActiveModal);

    ngOnInit() {
        this._setTexts();
    }

    private _setTexts() {

        if (this.default) {
            return;
        }
        if (this.withError) {
            this.texts = {
                title: `Point domain`,
                subtitle: `Replace the default nameservers at your domain registrar with 10Web nameservers.`
            }
        }

        if (this.pointed) {
            this.texts = {
                title: `Domain currently uses 10Web nameservers`,
                subtitle: ''
            }
        }
    }

    public copied(index: number) {
        this.isCopied[index] = true;
        setTimeout(() => this.isCopied[index] = false, 800);
    }

    close() {
        this._activeModal.close();
    }
}
